import React, { useState, useEffect } from "react";
import "./AdContainer.scss";
import { useTranslation } from "react-i18next";
import sizeMe from "react-sizeme";

function AdContainer({ location, size }) {
  const [fetching, setFetching] = useState(false);
  const [ads, setAds] = useState(null);
  const [lastLocation, setLastLocation] = useState(null);

  const { t } = useTranslation();

  useEffect(() => {
    //console.log("ad sensor effect", location);
    if (!fetching && (ads === null || location.pathname !== lastLocation)) {
      let url =
        window.serverUrl+"/social/ads/ads.php?&t=" + Math.random();
      setFetching((f) => true);
      setLastLocation((l) => location.pathname);
      fetch(url)
        .then((r) => r.json())
        .then((_data) => {
          setFetching((f) => false);
          setAds((u) => _data);
        })
        .catch((err) => {
          setFetching((f) => false);
          console.error("fetch problem", err);
        });
    }
    return () => {};
  }, [fetching, size.width, ads, lastLocation, location]);

  return (
    <>
      {ads !== null ? (
        <div className="ad-container">
          <div className="title">{t("ads.sponsored")}</div>
          {!fetching && ads !== null && size.width > 0 ? (
            <>
              <a
                href={ads.small.link}
                className="small"
                alt=""
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={ads.small.url} alt="" />
              </a>
              <a
                href={ads.large.link}
                className="large"
                alt=""
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={ads.large.url} alt="" />
              </a>
            </>
          ) : (
            <></>
          )}
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
export default sizeMe({
  monitorWidth: true
})(AdContainer);
